module.exports = __webpack_public_path__ + "assets/upload_document.edc68f22.svg";